(() => {
  angular
    .module('app.report')
    .controller('QualityReportController', QualityReport);

  QualityReport.$inject = [
    '$q',
    '$scope',
    '$filter',
    '$timeout',
    '$interval',
    '$location',
    '$routeParams',
    'Report',
    'CampaignManagerService',
  ];

  function QualityReport(
    $q,
    $scope,
    $filter,
    $timeout,
    $interval,
    $location,
    $routeParams,
    Report,
    CampaignManagerService,
  ) {
    const { report } = $scope.$parent;
    const vm = this;
    let loadQueue = [];

    vm.hasData = report.campaign.hasData;
    vm.existMetrics = [];
    vm.showImpressionMatrix = false;
    vm.campaignId = CampaignManagerService.getCampaignData().pid;
    vm.isOldCampaign = new Date(report.campaign.startDate) < new Date('09-24-2018');
    vm.noImpressions = !report.campaign.reportItems.some(item => item.eventType === 'impression');

    $scope.goToActivate = () => {
      window.location.pathname = `/campaign/edit/${report.campaignIdParam.id}/quality`;
    };

    $scope.goToTrackpoints = () => {
      window.location.pathname = `/campaign/edit/${report.campaignIdParam.id}/trackingpoints`;
    };

    if (vm.isOldCampaign || vm.noImpressions) {
      report.isCampaignLoading = false;
      report.isCampaignLoaded = true;
      vm.abortLoading = true;
      return false;
    }

    activate();
    function activate() {
      report.isCampaignLoading = true;
      report.subActivate = activate;

      if (!report.isQualityLoaded) {
        report.qualityCache = {};

        if (isActiveMetric('viewability')) {
          loadViewability();
        }
        if (isActiveMetric('transparency')) {
          loadTransparency();
        }
        if (isActiveMetric('geoCompliance')) {
          loadGeoCompliance();
        }

        const interval = $interval(() => {
          if (loadQueue.length === 0) {
            loadOverview();
            $interval.cancel(interval);
          }
        }, 300);
      } else {
        if (isActiveMetric('viewability')) {
          initViewability();
        }
        if (isActiveMetric('transparency')) {
          initTransparency();
        }
        if (isActiveMetric('geoCompliance')) {
          initGeoCompliance();
        }
        initOverview();

        vm.loaded = true;
      }
    }

    function loadViewability() {
      loadQueue.push('viewability');
      Report.getQualityViewability(report.campaignIdParam)
        .$promise.then(
          ({ data }) => {
            report.qualityCache = {
              ...report.qualityCache,
              viewability: data,
            };
            initViewability();

            loadQueue = loadQueue.filter(item => item !== 'viewability');
          });
    }

    function loadTransparency() {
      loadQueue.push('transparency');
      Report.getQualityTransparency(report.campaignIdParam)
        .$promise.then(
          ({ data }) => {
            report.qualityCache = {
              ...report.qualityCache,
              transparency: data,
            };
            initTransparency();

            loadQueue = loadQueue.filter(item => item !== 'transparency');
          });
    }

    function loadGeoCompliance() {
      loadQueue.push('geoCompliance');
      Report.getQualityGeoCompliance(report.campaignIdParam)
        .$promise.then(
          ({ data }) => {
            report.qualityCache = {
              ...report.qualityCache,
              geoCompliance: data,
            };
            initGeoCompliance();

            loadQueue = loadQueue.filter(item => item !== 'geoCompliance');
          });
    }

    function loadOverview() {
      Report.getQualityOverview(report.campaignIdParam)
        .$promise.then(({ data }) => {
          report.qualityCache = {
            ...report.qualityCache,
            overview: data,
            selectedMetric: $routeParams.metric,
          };
          initOverview();

          vm.loaded = true;
          report.isCampaignLoading = false;
          report.isCampaignLoaded = true;
          report.isQualityLoaded = true;

          $timeout(() => {
            $(window).resize();
          }, 1000);
        });
    }

    function initOverview() {
      const { overview } = report.qualityCache;

      if (overview.ex) {
        console.error(overview);
        vm.overviewError = true;
        return false;
      }

      const metricScore = {};

      if (vm.viewability && !vm.viewability.ex) {
        const { events: { total: vTotal, notViewable } } = vm.viewability.overview;
        metricScore['viewability'] = vTotal > 0 ? Math.round(notViewable / vTotal * 100) : 0;
      }

      if (vm.transparency && !vm.transparency.ex) {
        const { events: { total: tTotal, withUnknownReferrer } } = vm.transparency.overview;
        metricScore['transparency'] = tTotal > 0 ? Math.round(withUnknownReferrer / tTotal * 100) : 0;
      }

      if (vm.geoCompliance && !vm.geoCompliance.ex) {
        const { events: { total: gTotal, notInTargetCountry } } = vm.geoCompliance.overview;
        metricScore['geoCompliance'] = gTotal > 0 ? Math.round((100 - notInTargetCountry) / (gTotal * 100)) : 0;
      }

      vm.getMetricScore = metric => metricScore[metric];
      vm.overview = {
        ...overview.overview,
        metrics: overview.metrics,
      };
      vm.showImpressionMatrix = true;

      initMetricsNav();
    }

    function initGeoCompliance() {
      const { geoCompliance } = report.qualityCache;

      if (geoCompliance.ex) {
        console.error(geoCompliance);
        vm.geoComplianceError = true;
        return false;
      }

      const { overview, trackpoints } = geoCompliance;
      const { events, targetCountry } = overview;

      window.geoCompliance = geoCompliance.countries; // FIXME
      window.targetCountry = targetCountry; // FIXME

      const locationsPerPage = 10;
      vm.locationsCurrentPage = 0;
      vm.locationsMaxPages = Math.round(geoCompliance.countries.length / locationsPerPage);
      vm.locationsMaxRangePages = vm.locationsMaxPages < 5 ? vm.locationsMaxPages : 5;
      vm.locationsRangePages = [];

      $scope.prevLocationsPage = () => {
        if (vm.locationsCurrentPage > 0) {
          vm.locationsCurrentPage--;
        }
        vm.geoCompliance.details = getLocationDetails();
      };

      $scope.nextLocationsPage = () => {
        if (vm.locationsCurrentPage < vm.locationsMaxPages - 1) {
          vm.locationsCurrentPage++;
        }
        vm.geoCompliance.details = getLocationDetails();
      };

      $scope.setLocationsPage = page => {
        vm.locationsCurrentPage = page;
        vm.geoCompliance.details = getLocationDetails();
      };

      const setLocationsRangePages = () => {
        const current = vm.locationsCurrentPage;
        const max = vm.locationsMaxPages;
        const maxRange = vm.locationsMaxRangePages;
        const range = [];

        if (current >= maxRange && current <= max - maxRange) {
          for (let i = current - Math.floor(maxRange / 2); i <= current + Math.floor(maxRange / 2); i++) {
            range.push({ number: i });
          }
        } else if (current < maxRange) {
          for (let i = 0; i < maxRange; i++) {
            range.push({ number: i });
          }
        } else if (current > max - maxRange) {
          for (let i = max - maxRange; i < max; i++) {
            range.push({ number: i });
          }
        }

        vm.locationsRangePages = range;
      }

      const getLocationDetails = () => {
        const { countries } = geoCompliance;

        const totalEvents = countries.reduce((memo, item) => memo + item.events, 0);
        const locations = countries
          .filter(country => country.countryCode !== 'n/a')
          .sort((a, b) => b.events - a.events)
          .splice(vm.locationsCurrentPage * locationsPerPage, locationsPerPage)
          .reduce((memo, country) => {
            const isTargetLocation = country.countryCode === targetCountry;
            const location = {
              ...country,
              isTargetLocation,
              code: country.countryCode.toLowerCase(),
              name: country.countryCode,
              rate: (country.events * 100) / totalEvents,
              regions: country.regions.filter(region => region.name !== 'n/a'),
              expanded: false,
              className: '',
            };
            memo.push(location);

            if (location.regions && location.regions.length > 0) {
              location.regions
                .sort((a, b) => b.events - a.events)
                .map(region => {
                  const regionRate = (region.events * 100) / totalEvents;
                  memo.push({
                    ...region,
                    isTargetLocation,
                    rate: regionRate,
                    rootName: location.name,
                    subRegions: region.subRegions.filter(subRegion => subRegion.name !== 'n/a'),
                    hidden: true,
                    expanded: false,
                    className: `flag flag-region ${isTargetLocation ? 'success' : 'danger'}`,
                  });

                  if (region.subRegions && region.subRegions.length > 0) {
                    region.subRegions
                      .sort((a, b) => b.events - a.events)
                      .map(subRegion => {
                        const subRegionRate = (subRegion.events * 100) / totalEvents;
                        memo.push({
                          ...subRegion,
                          isTargetLocation,
                          rate: subRegionRate,
                          rootName: region.name,
                          locationName: location.name,
                          hidden: true,
                          className: `flag flag-sub-region ${isTargetLocation ? 'success' : 'danger'}`,
                        });
                      });
                  }
                });
            }

            return memo;
          }, []);

        setLocationsRangePages();
        return {
          locations,
          total: {
            events: totalEvents,
            rate: 100,
          }
        };
      }

      vm.geoCompliance = {
        ...geoCompliance,
        targetCountry,
        eventsTotal: events.total,
        impressionsInside: events.total - events.notInTargetCountry || 0,
        impressionsOutside: events.notInTargetCountry || 0,
        graph: getGraphData(overview.trackpoints),
        trackpoints: getTrackpoints(trackpoints, 'notTargetCountry'),
        details: getLocationDetails(),
      };

      const notTC = Math.round(events.notInTargetCountry * 100 / events.total) || 0;
      vm.geoCompliance.pieConfig = {
        inside: getPieConfig([{ y: 100 - notTC }, { y: notTC }], 0),
        outside: getPieConfig([{ y: 100 - notTC }, { y: 100 - (100 - notTC) }], 1),
      };

      // trackpoints
      vm.geoCompliance.tpTotal = {
        total: trackpoints.reduce((sum, { events }) => sum + events.total, 0),
        notTC: trackpoints.reduce((sum, { events }) => sum + events.notTargetCountry, 0),
      };
    }

    function initTransparency() {
      const {
        transparency,
        transparency: { overview, trackpoints },
      } = report.qualityCache;

      if (transparency.ex) {
        console.error(transparency);
        vm.transparencyError = true;
        return false;
      }

      const { events } = overview;

      // overview
      vm.transparency = {
        ...transparency,
        eventsTotal: events.total,
        mediaReferrer: events.total - events.withUnknownReferrer || 0,
        hiddenReferrer: events.withUnknownReferrer || 0,
        graph: getGraphData(overview.trackpoints),
        trackpoints: getTrackpoints(trackpoints, 'withGenericReferrers'),
      };

      const mr = Math.round(vm.transparency.mediaReferrer * 100 / events.total) || 0; // mediaReferrer
      vm.transparency.pieConfig = {
        mediaReferrer: getPieConfig([{ y: mr }, { y: 100 - mr }], 0),
        hiddenReferrer: getPieConfig([{ y: 100 - (100 - mr) }, { y: 100 - mr }], 1)
      };

      // trackpoints
      vm.transparency.tpTotal = {
        total: trackpoints.reduce((sum, { events }) => sum + events.total, 0),
        GR: trackpoints.reduce((sum, { events }) => sum + events.withGenericReferrers, 0),
        HR: trackpoints.reduce((sum, { events }) => sum + events.withHiddenReferrers, 0),
      };
    }

    function initViewability() {
      const {
        viewability,
        viewability: { overview, trackpoints },
      } = report.qualityCache;

      if (viewability.ex) {
        console.error(viewability);
        vm.viewabilityError = true;
        return false;
      }

      const { events } = overview;

      vm.viewability = {
        ...viewability,
        eventsTotal: events.total,
        viewable: events.total - events.notViewable || 0,
        notViewable: events.notViewable || 0,
        graph: getGraphData(overview.trackpoints),
        trackpoints: getTrackpoints(trackpoints, 'notViewable'),
      };

      const viewable = Math.round(vm.viewability.viewable * 100 / events.total) || 0; // mediaReferrer
      vm.viewability.pieConfig = {
        viewable: getPieConfig([{ y: viewable }, { y: 100 - viewable }], 0),
        notViewable: getPieConfig([{ y: 100 - (100 - viewable) }, { y: 100 - viewable }], 1)
      };

      // trackpoints
      vm.viewability.tpTotal = {
        total: trackpoints.reduce((sum, { events }) => sum + events.total, 0),
        notVW: trackpoints.reduce((sum, { events }) => sum + events.notViewable, 0),
      };
    }

    $scope.onCollapseTransparency = trackpointName => {
      vm.transparency.trackpoints = onCollapse(vm.transparency.trackpoints, trackpointName);
    };

    $scope.onCollapseViewability = trackpointName => {
      vm.viewability.trackpoints = onCollapse(vm.viewability.trackpoints, trackpointName);
    };

    $scope.onCollapseGeoCompliance = trackpointName => {
      vm.geoCompliance.trackpoints = onCollapse(vm.geoCompliance.trackpoints, trackpointName);
    };

    $scope.onCollapseLocation = name => {
      vm.geoCompliance.details.locations = onCollapseLocation(name);
    };

    $scope.hiddenFilter = ({ hidden, trackpointName }) => !(hidden && trackpointName);
    $scope.hiddenLocationFilter = ({ hidden, name }) => !(hidden && name);

    function onCollapse(trackpoints, trackpointName) {
      return trackpoints.map(trackpoint => ({
        ...trackpoint,
        hidden: trackpoint.name === trackpointName || trackpoint.trackpointName === trackpointName ?
          !trackpoint.hidden : trackpoint.hidden,
      }));
    }

    function onCollapseLocation(name) {
      const { locations } = vm.geoCompliance.details;
      const location = locations.find(item => item.name === name);
      location.expanded = !location.expanded;

      const hidden = item => {
        if (item.locationName === name && !location.expanded) {
          return true;
        }
        return item.rootName === name ? !item.hidden : item.hidden;
      };

      const expanded = item => {
        if (item.rootName === name && !location.expanded) {
          return false;
        }
        return item.expanded;
      };

      return [...locations]
        .map(item => ({
          ...item,
          expanded: expanded(item),
          hidden: hidden(item),
        }));
    }

    function getTrackpoints(trackpoints, sortBy) {
      return trackpoints
        .sort((a, b) => b.events[sortBy] - a.events[sortBy])
        .reduce((memo, tp) => {
          memo.push({ ...tp, hidden: true});

          if (tp.referrers && tp.referrers.length > 0) {
            memo.push(...tp.referrers
              .sort((a, b) => b.events[sortBy] - a.events[sortBy])
              .map(item => ({ ...item, trackpointName: tp.name, hidden: true })));
          }

          return memo;
        }, []);
    }

    function getExistMetrics() {
      const { metrics } = vm.overview;
      if (!metrics) {
        return [];
      }

      return metrics.reduce((memo, { name, score }) => {
        const metric = vm.nav.items.find(item => item.name === name);
        return metric && isActiveMetric(metric.name) ?
          [
            ...memo, {
              ...metric,
              id: metric.id,
              score,
            }
          ] : memo
      }, []);
    }

    function isActiveMetric(metricName) {
      const { activeMetrics } = report.campaign;
      return !!activeMetrics.find(metric => metric.name === metricName);
    }

    function getCurrentMetric() {
      const metric = report.qualityCache.selectedMetric || '';
      return metric;
    }

    function setCurrentMetric(metric) {
      $location.path(`quality/${metric}`);
      report.qualityCache.selectedMetric = metric;
    }

    function initMetricsNav() {
      vm.nav = {
        items: [{
          name: 'geoCompliance',
          title: 'Geo Compliance',
          description: 'Does the ad load in the correct geographical area?',
        }, {
          name: 'brandSafety',
          title: 'Brand Safety',
          description: 'Does the ad appear alongside negative listed content?',
        }, {
          name: 'relevance',
          title: 'Relevance',
          description: 'Does the ad appear alongside relevant content?',
        }, {
          name: 'mediaQuality',
          title: 'Media Quality',
          description: 'Does the ad appear on safe and popular medias?',
        }, {
          name: 'viewability',
          title: 'Viewability',
          description: 'Are ads viewable for human eyes?',
        }, {
          name: 'bots',
          title: 'Bots',
          description: 'Are ads loaded by suspicious devices?',
        }, {
          name: 'adCollision',
          title: 'Ad Collision',
          description: 'Are ads shown multiple times at the same location?',
        }, {
          name: 'transparency',
          title: 'Transparency',
          description: 'Does the provider try to obscure where the ad is served?',
        }],

        setCurrentMetric: metric => setCurrentMetric(metric),
        isDefault: () => !getCurrentMetric(),
      };

      vm.existMetrics = getExistMetrics();

      $timeout(() => {
        vm.currentMetric = getCurrentMetric();
      }, 100);
    }

    $scope.goToMetric = metric => {
      const path = metric ? `/${metric}` : '';
      $location.path(`/quality${path}`);
      report.qualityCache.selectedMetric = metric || '';
    };

    function onPopState() {
      if ($location.path().includes('/quality')) {
        const metric = $location.path().split('/quality/')[1] || '';
        $scope.goToMetric(metric);
      } else {
        window.removeEventListener('popstate', onPopState);
      }
    }

    window.addEventListener('popstate', onPopState);
  }

  function getGraphData(trackpoints) {
    const dots = [];
    if (!trackpoints) {
      return { dots };
    }

    const { total, violating: value } = trackpoints;
    for (let i = 0; i < total; i++) {
      dots.push(i);
    }

    return {
      value,
      total,
      dots,
    }
  }

  function getPieConfig(data, place) {
    function getColors() {
      var schema = {
        neutral: '#ced4d6',
        danger:  '#ee5757',
        warning: '#dfc61f',
        success: '#9ee00f'
      };

      return place === 0
        ? [schema.success, schema.neutral]
        : [schema.neutral, schema.danger]
    }

    return {
      title: { text: null },
      options: {
        chart: {
          type: 'pie',
          height: 64,
          width: 64,
          margin: [0, 0, 0, 0],
          backgroundColor: null,
        },
        credits: {
          enabled: false
        },
        plotOptions: {
          pie: {
            size: '100%',
            showInLegend: false,
            borderWidth: 0,
            dataLabels: { enabled: false }
          },
          series: {
            allowPointSelect: false,
            states: {
              hover: { enabled: false }
            }
          }
        },
        tooltip: { enabled: false },
        colors: getColors()
      },
      series: [{
        data
      }]
    };
  }
})();
